import { maxLength, presence, ValidationField, Validator } from "~/extensions/utils";
import { commonStore } from "~/store/CommonStore";
import validate, { isEmpty } from "validate.js";
import { ResponseContent } from "~/extensions/utils/DefineTypes";
import { isNullOrUndefined } from "~/extensions/utils/DefineFunction";
export class InformationValidator extends Validator {
    constructor(vm) {
        const constrains = {
            responseReason: {
                responseNegativeIfRequired: presence(false, commonStore.messages.PV0001),
                length: maxLength(50)
            }
        };
        super(vm, constrains);
        this.responseReason = new ValidationField("responseReason", this.data, constrains);
    }
    responseReason;
}
/** 要回答の場合必須 */
validate.validators.responseNegativeIfRequired = function (value, options, key, attributes) {
    if (!(attributes.responseContent === ResponseContent.negative)) {
        return null;
    }
    if (isNullOrUndefined(value) || isEmpty(value)) {
        return options.message;
    }
    return null;
};
